// Get Promotion
export const GET_PROMOTION_REQUEST = 'GET_PROMOTION_REQUEST';
export const GET_PROMOTION_DONE = 'GET_PROMOTION_DONE';
export const GET_PROMOTION_FAILED = 'GET_PROMOTION_FAILED';

// Update Promotion
export const UPDATE_PROMOTION_REQUEST = 'UPDATE_PROMOTION_REQUEST';
export const UPDATE_PROMOTION_DONE = 'UPDATE_PROMOTION_DONE';
export const UPDATE_PROMOTION_FAILED = 'UPDATE_PROMOTION_FAILED';
export const UPDATE_PROMOTION_RESET = 'UPDATE_PROMOTION_RESET';